import 'magnific-popup'

export default {
    init() { 
        
        //password modal input focus
        var modal_rpassword = document.getElementById('resetpassword-modal')
        var form_rpassword = $('form#resetpassform')

        // Open Modal on restricted page
        if(modal_rpassword) {
            const queryString = window.location.search
            const urlParams = new URLSearchParams(queryString)

            if(urlParams.has('reset-password')) {
                openResetPasswordModal()
            }
        }



        // Function to open the modal
		function openResetPasswordModal() {
			$.magnificPopup.open({
				items: {
					src: '#resetpassword-modal'
				},
				type: 'inline',
				preloader: false,
				modal: true,
				callbacks: {
                    close: function() {

					},
					open: function() {


					},
				}
			})
		}


        //rpassword Submit trigger
        form_rpassword.on('submit', function (e) {
            e.preventDefault()
            
            const rpassword_status = $('form#resetpassform .resetpass-status')
            const submit_button = $(this).find('input[type="submit"], button[type="submit"]')

            let passwordValid = validatePasswords(this)

			if (passwordValid !== true) {
				rpassword_status.text(passwordValid).show()
				submit_button.prop('disabled', false)
				return false
			} else {
				rpassword_status.hide()
            }

            console.log(passwordValid)

            let data = form_rpassword.serializeArray()

            console.log(data)

            $.ajax({
                type: 'POST',
                dataType: 'json',
                url: my_ajax_object.ajax_url,
                data: data,
                beforeSend: function(){
                    submit_button.prop( "disabled", true )
                    rpassword_status.removeClass('success')
                    rpassword_status.removeClass('error')
                },
                success: function (response) {
                    rpassword_status.show().text(response.data.message)

                    if(response.success === true) {
                        rpassword_status.addClass('success')

                        setTimeout(function() {
                            rpassword_status.hide()
                            $.magnificPopup.close()
                            $.magnificPopup.open({
                                items: {
                                    src: '#login-modal'
                                },
                                type: 'inline',
                                preloader: false,
                                modal: true
                            })
                        }, 3000)

                    } else {
                        rpassword_status.addClass('error')
                        submit_button.prop( "disabled", false )
                    }

                }
            })
        })



        function validatePasswords(ths) {
            let all_pass = true
            let error_response = ''

            const ths_form = $(ths)
            const password = ths_form.find('input[name="pass1"]').val()
            const conf = ths_form.find('input[name="pass2"]').val()

            const uppercase = password.match(/[A-Z]/)
            const number = password.match(/[0-9]/)
            const special = password.match(/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/)
            const lowercase = password.match(/[a-z]/)

            if (password.length < 6) {
                error_response = 'Geslo mora imeti najmanj 6 simbolov'
                all_pass = false
            }

            if (!uppercase) {
                all_pass = false
                error_response = 'Geslo mora vključevati vsaj eno veliko črko'
            }

            if (!lowercase) {
                all_pass = false
                error_response = 'Geslo mora vključevati vsaj eno malo črko'
            }

            if (!(number || special)) {
                all_pass = false
                error_response = 'Geslo mora vključevati vsaj eno številko ali simbol'
            }

            if (!(password == conf && password != '')) {
                all_pass = false
                error_response = 'Geslo in geslo za potrditev se ne ujemata'
            }

            if (!all_pass) {
                return error_response
            }

            return true
        }


    }
}